import { v4 as uuidv4 } from 'uuid';

import { AppThunk } from '../../app/store';
import { evidenceRetryEndPoint } from '../../common/api.endPoints';
import { HttpService } from '../../common/http.service';
import { erroredTaskListActions } from './erroredTaskListSlice';

export const retryEvidence =
  (
    applicationId: number,
    taskId: number,
    openSnacks: any,
    setSnacksCallback: (updatedSnacks: any) => void,
  ): AppThunk =>
  async dispatch => {
    dispatch(erroredTaskListActions.onTaskRetry({ taskId }));

    const data = await HttpService.getInstance().patch(
      evidenceRetryEndPoint(applicationId.toString(), taskId),
    );

    if (data && !data.error) {
      dispatch(erroredTaskListActions.onTaskRetrySuccess({ taskId }));
    } else {
      dispatch(erroredTaskListActions.onTaskRetryError({ taskId }));
      if (data && data.error) {
        setSnacksCallback([
          ...openSnacks,
          {
            id: uuidv4(),
            type: data.error.type,
            message: data.error.message,
          },
        ]);
      }
    }
  };
